import "../styles/Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 FlipBookMart — Created by Sachin</p>
      <div className="footer-links">
        <a href="/">About</a>
        <a href="/">Contact</a>
        <a href="/">Privacy</a>
      </div>
    </footer>
  );
}
